<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wNf5Tn/tc-custom/9781639843275.jpg?1704286950431" alt="This image is the cover for the book Willow's Flame"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Willow's Flame
      </h1>
      <p class="bookDescription body article font2">
        <b>A woman’s disappearance shakes up a love triangle in this “terrifyingly wicked psychological thriller” from the author of <i>Mirror</i> and <i>Under</i> (Alisa H. Klinger, author of </b><i><b>The Perfect Move).</b></i><br/>  <br/> So, what is it exactly that labels one a serial killer? Is it the amount of people that you kill, statistically speaking? What if the killing is within reason? Can the murder, or murders, be justified? If the world is a better place without the people who are killed, is it really such a tragedy?<br/>  <br/><i>“A serial killer is typically a person who murders three or more people, usually in service of abnormal psychological gratification, with the murders taking place over more than a month and including a significant period of time between them.” —</i>Wikipedia<br/>  <br/> In what would seem to be a cozy home in Chicago, a young couple seem to have it all, Willow finds herself questioning the life she chose with her husband Neil. When his secrets begin to unfold, she gets caught up in a spicy affair with a man she meets at a book club. It turns out Neil isn’t the only one bearing secrets. Pauleen, who’s named The Nosey Neighbor, hears it all through the thin walls and starts to connect the dots herself when poor, sweet Willow goes missing.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephanie Fields
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen It! Publications, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e5d97bae